import MapEditType from "@/constant/MapElementType";
import BasePoint from "@/model/BasePoint";

const MeshTagIdPrefix = "IdriverplusThreeMeshTagIdPrefix"; //Mesh对象的name的id前缀

const originPoint2LocalPoint = (
  //把真实坐标转换成画图的坐标
  x: number,
  y: number,
  leftBoundary: number, //真实地图的左下角为原点的坐标点x
  downBoundary: number, //真实地图的左下角为原点的坐标点y
  pixelExtent: number, //像素比例 1像素代表的距离
  mapPicWidth: number, //图片的宽和高
  mapPicHeight: number //图片的宽和高
): { localX: number; localY: number } => {
  //转换成本地画布上可用的点
  const px = (x - leftBoundary) / pixelExtent - mapPicWidth / 2;
  const py = (y - downBoundary) / pixelExtent - mapPicHeight / 2;
  const localX = Math.round(px * 100) / 100;
  const localY = Math.round(py * 100) / 100;

  // const localX = (x - leftBoundary) / pixelExtent;
  // const localY = (y - downBoundary) / pixelExtent;

  return { localX, localY };
};

const translateLocalToOrigin = (
  //把画图的坐标转换成真实坐标
  x: number,
  y: number,
  leftBoundary: number, //真实地图的左下角为原点的坐标点x
  downBoundary: number, //真实地图的左下角为原点的坐标点y
  pixelExtent: number, //像素比例 1像素代表的距离
  mapWidth: number,
  mapHeight: number
): { originX: number; originY: number } => {
  //转换成本地画布上可用的点
  const originX = leftBoundary + (x + mapWidth / 2) * pixelExtent;
  const originY = (y + mapHeight / 2) * pixelExtent + downBoundary;

  return { originX, originY };
};

const getPointAfterCanvasRotate = (
  afterPointX: number,
  afterPointY: number,
  angle: number
): { x: number; y: number } => {
  //获取屏幕对应画布上旋转变换后的点位置（即旋转后的位置）。
  const x1 = afterPointX;
  const y1 = afterPointY;

  const w = x1;
  const h = y1;
  // (Math.acos(cosM) * 180 / Math.PI * k);
  const tanAngle = (Math.atan2(h, w) * 180) / Math.PI;
  const curAngle = tanAngle - angle;
  const radius = Math.sqrt(w * w + h * h);
  const w2 = radius * Math.cos((Math.PI / 180) * curAngle);
  const h2 = radius * Math.sin((Math.PI / 180) * curAngle);
  const x = -w2;
  const y = h2;
  return { x: x, y: y };
};

const getPointBeforeCanvasZoomAndTranslation = (
  canvasTransX: number,
  canvasTransY: number
): { x: number; y: number } => {
  //获取屏幕选中的对应画布上缩放平移变换前的点的原始位置（即未缩放平移时的位置）。
  const choosePointX = -canvasTransX;
  const choosePointY = canvasTransY;
  const anchorPointChoosePoint = { x: choosePointX, y: choosePointY }; //锚点选中的点
  return anchorPointChoosePoint;
};

const getPointBeforeCanvasRotate = (
  activePointX: number,
  activePointY: number,
  angle: number
): { x: number; y: number } => {
  //获取屏幕选中的对应画布上旋转变换前的点的原始位置（即未旋转时的位置）。
  const x1 = activePointX;
  const y1 = activePointY;
  const x2 = 0;
  const y2 = 0;
  const currentAngle = (angle * Math.PI) / 180;
  const x =
    (x1 - x2) * Math.cos(currentAngle) -
    (y1 - y2) * Math.sin(currentAngle) +
    x2;
  const y =
    (x1 - x2) * Math.sin(currentAngle) +
    (y1 - y2) * Math.cos(currentAngle) +
    y2;
  return { x: x, y: y };
};

const getPointBeforeCanvasTransformation = (
  canvasTransX: number,
  canvasTransY: number,
  canvasRotate: number
): { x: number; y: number } => {
  const currentTranslationZoomPoint = getPointBeforeCanvasZoomAndTranslation(
    canvasTransX,
    canvasTransY
  );
  const currentRotatePoint = getPointBeforeCanvasRotate(
    currentTranslationZoomPoint.x,
    currentTranslationZoomPoint.y,
    canvasRotate
  );
  return currentRotatePoint;
};

const getFuncPointTextForType = (pointType: number): string => {
  let text = "";
  switch (pointType) {
    case MapEditType.edit_func_navigation_point_type_4:
      text = "【" + "导航点" + "】";
      break;
    case MapEditType.edit_func_stop_point_type_5:
      text = "【" + "停靠点" + "】";
      break;
    case MapEditType.edit_func_depot_point_type_6:
      text = "【" + "补给站" + "】";
      break;
    case MapEditType.task_func_point_navigation_type_7:
      text = "【" + "导航点" + "】";
      break;
    case MapEditType.edit_func_wait_lift_point_type_8:
      text = "【" + "候梯点" + "】";
      break;
    case MapEditType.edit_func_rfid_point_type_10:
      text = "【" + "跌落点" + "】";
      break;
  }
  return text;
};

const getFuncPointShowForType = (pointType: number): boolean => {
  let show = true;
  switch (pointType) {
    case MapEditType.edit_func_floor_point_type_9:
      show = false;
      break;
  }
  return show;
};

const getFuncAreaTextForType = (pointType: number): string => {
  let text = "";
  switch (pointType) {
    case MapEditType.edit_func_area_type_carpet_1:
      text = "【" + "地毯区" + "】";
      break;
    case MapEditType.edit_func_area_type_speed_jhump_2:
      text = "【" + "减速带" + "】";
      break;
    case MapEditType.edit_func_area_type_no_entry_3:
      text = "【" + "禁行区" + "】";
      break;
    case MapEditType.edit_func_area_type_glassArea_4:
      text = "【" + "玻璃区" + "】";
      break;
    case MapEditType.edit_func_area_type_slopeArea_5:
      text = "【" + "斜坡区" + "】";
      break;
    case MapEditType.edit_func_area_type_liftArea_6:
      text = "【" + "电梯区" + "】";
      break;
    case MapEditType.edit_func_area_type_dynamicArea_7:
      text = "【" + "动态区" + "】";
      break;
    case MapEditType.edit_func_area_type_warningArea_8:
      text = "【" + "警示区" + "】";
      break;
    case MapEditType.edit_func_area_type_floor_lamps_9:
      text = "【" + "地灯" + "】";
      break;
    case MapEditType.edit_func_area_type_blindPathArea_10:
      text = "【" + "盲道" + "】";
      break;
  }

  return text;
};

const getVerticalSlopeTwoPoint = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  dis: number,
  x3: number,
  y3: number
): BasePoint[] => {
  //获取垂直斜率两点,x3,y3再前面两点的线上
  const slope = (y2 - y1) / (x2 - x1);
  const cm2Pixel = 5; //厘米转像素
  let tempDis = 0;
  if (dis > 0) {
    tempDis = dis / cm2Pixel;
  }
  const fAngle = Math.abs((Math.atan(slope) * 180) / Math.PI);
  const ydis = Math.abs(Math.cos((fAngle * Math.PI) / 180) * tempDis);
  const xdis = Math.abs(Math.sin((fAngle * Math.PI) / 180) * tempDis);
  let p1: BasePoint, p2: BasePoint;
  if ((y2 > y1 && x2 > x1) || (y2 < y1 && x2 < x1)) {
    p1 = { x: x3 - xdis, y: y3 + ydis };
    p2 = { x: x3 + xdis, y: y3 - ydis };
  } else {
    p1 = { x: x3 - xdis, y: y3 - ydis };
    p2 = { x: x3 + xdis, y: y3 + ydis };
  }
  return [p1, p2];
};

const getOrigin2LocalPoint = (
  //把真实坐标转换成画图的坐标
  x: number,
  y: number,
  leftBoundary: number, //真实地图的左下角为原点的坐标点x
  downBoundary: number, //真实地图的左下角为原点的坐标点y
  pixelExtent: number, //像素比例 1像素代表的距离
  mapPicWidth: number, //图片的宽和高
  mapPicHeight: number //图片的宽和高
): { localX: number; localY: number } => {
  //转换成本地画布上可用的点
  const px = (x - leftBoundary) / pixelExtent;
  const py = mapPicHeight - (y - downBoundary) / pixelExtent;
  const localX = Math.round(px * 100) / 100;
  const localY = Math.round(py * 100) / 100;
  return { localX, localY };
};

const getLocalToOriginPoint = (
  //把画图的坐标转换成真实坐标
  x: number,
  y: number,
  leftBoundary: number, //真实地图的左下角为原点的坐标点x
  downBoundary: number, //真实地图的左下角为原点的坐标点y
  pixelExtent: number, //像素比例 1像素代表的距离
  mapWidth: number,
  mapHeight: number
): { originX: number; originY: number } => {
  //转换成本地画布上可用的点
  const originX = leftBoundary + x * pixelExtent;
  const originY = (mapHeight - y) * pixelExtent + downBoundary;
  return { originX, originY };
};
export {
  MeshTagIdPrefix,
  originPoint2LocalPoint,
  translateLocalToOrigin,
  getPointBeforeCanvasTransformation,
  getPointBeforeCanvasRotate,
  getPointAfterCanvasRotate,
  getFuncPointTextForType,
  getFuncAreaTextForType,
  getVerticalSlopeTwoPoint,
  getFuncPointShowForType,
  getOrigin2LocalPoint,
  getLocalToOriginPoint,
};
